import Action from "./Action";
import $ from "jquery";
import "bootstrap";

import "./PopOverAction.css";

let spinnerTemplate = '<i class="fa fa-gear fa-spin" style="font-size:24px; opacity: 0.5;"></i>';

export default class PopOverAction extends Action {
    constructor(param) {
        super(param);

        this._hideTrigger = param.hideTrigger || 'out';
        this._placement = param.placement || 'bottom';
        this._contentUrl = param.contentUrl;
        this._html = param.html;
    }

    perform(scope) {
        super.perform(scope);

        if (!this._anchor) {
            this._anchor = new PopOverAnchor(scope.chart.canvas.parentElement, scope.x, scope.y, this._placement);

            if (this._hideTrigger === 'blur') {
                $(document).click((event) => {
                    if (this._anchor.popover) {
                        let bounds = this._anchor.popover.getBoundingClientRect();

                        if ((event.clientX > bounds.left) && (event.clientX < bounds.right)
                            && (event.clientY > bounds.top) && (event.clientY < bounds.bottom)) return;
                    }
                    this._anchor.hidePopover();
                });
            }
        }

        this._anchor.x = scope.x;
        this._anchor.y = scope.y;
        this._anchor.visible = true;

        this._anchor.content =  this._html ? this.applyVariables(this._html, scope) : spinnerTemplate;
        this._anchor.showPopover();

        if (this._contentUrl) {
            // TODO: delay/abort requests?
            // TODO: cache requests?

            $.ajax({url: this.applyVariables(this._contentUrl, scope)}).done((result) => {
                this._anchor.content = this.applyVariables(result, scope);
            }).fail(() => {
                // TODO: Error message
                this._anchor.hidePopover();
            });
        }
    }

    deactivate() {
        if (this._hideTrigger === 'out') {
            this._anchor && this._anchor.hidePopover();
        }
    }
}

Action.register("popover", PopOverAction);

class ElementController {
    constructor(display) {
        this.display = display;
    }

    get x() {
        return this._x
    }

    set x(value) {
        this._x = value;
        this.display.style.left = Math.round(value) + "px";
    }

    get y() {
        return this._y
    }

    set y(value) {
        this._y = value;
        this.display.style.top = Math.round(value) + "px";
    }

    get visible() {
        return this._visible;
    }

    set visible(value) {
        this._visible = value;
        this.display.style.display = value ? "block" : "none";
    }
}

class PopOverAnchor extends ElementController {
    constructor(parent, x, y, placement) {
        super();

        this.display = document.createElement('div');
        this.display.classList.add("popover-action__anchor");

        this.x = x;
        this.y = y;

        parent.appendChild(this.display);
        $(this.display).popover({
            trigger: 'manual',
            placement: placement,
            html: true
        });
    }

    get popover() {
        return this.display.parentNode.querySelector(".popover");
        // return $(this.display).parent().find(".popover");
    }

    get content() {
        return this.display.getAttribute("data-content");
    }
    set content(value) {
        this.display.setAttribute("data-content", value);

        this._render();
    }

    _render() {
        if (! this._showing) return;

        let display = $(this.display);
        let popover = display.data('bs.popover');

        let anim = popover.options.animation;
        popover.options.animation = false;
        display.popover('show');
        popover.options.animation = anim;
    }

    showPopover() {
        let display = $(this.display);

        if (! this._showing) {
            display.popover('show');
        } else {
            this._render();
        }
        this._showing = true;
    }

    hidePopover() {
        if (!this._showing) return;
        this._showing = false;
        $(this.display).popover('hide');
    }
}


// WEBPACK FOOTER //
// ./src/components/chart/actions/PopOverAction.js